import UPDatepicker from './UPDatepicker';

export default UPDatepicker;
